var _rect, _rect2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCondo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.72,
    y: 13.32,
    width: 35.36,
    height: 2.36,
    rx: 0.68,
    stroke: "#fff",
    strokeWidth: 0.64
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.72,
    y: 48.32,
    width: 40.36,
    height: 4.36,
    rx: 0.68,
    stroke: "#fff",
    strokeWidth: 0.64
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.64,
    d: "M20.72 20.32h4.36v8.36h-4.36zM20.72 35.32h4.36v8.36h-4.36zM30.72 20.32h4.36v8.36h-4.36zM40.72 20.32h4.36v8.36h-4.36zM40.72 35.32h4.36v8.36h-4.36zM16.4 13a1 1 0 0 1 1-1h32a1 1 0 0 1 1 1M16.72 16v32M49.72 16v32M20.4 23.68h5M20.4 38.68h5M30.4 23.68h5M40.4 23.68h5M40.4 38.68h5M29.4 48V34h7v14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    d: "M34.72 41.68h1.36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.64,
    d: "M27.4 49.68h10M27.4 51.18h10M27.72 48v5M37.72 48v5M22.82 24v5M22.82 39v5M32.82 24v5M42.82 24v5M42.82 39v5M37.4 12V7.5h6.5V12"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondo);
export default __webpack_public_path__ + "static/media/condo.ec171863f702d62eab11d5d4321b6638.svg";
export { ForwardRef as ReactComponent };